import { AsLabel } from '@adserve/adserve-react-components';
import React from 'react';

const AsTextarea = ({
    id = 'as-textarea',
    name,
    title,
    value,
    onChange,
    disabled = false,
    labelStyle,
    inputStyle,
    cols = 20,
    rows = 3,
    wrap = 'soft',
    maxLength,
    labelProps,
    inputProps,
    ...props
}) => {
    labelStyle = {
        display: 'block',
        textAlign: 'left',
        color: '#414141',
        ...props.style,
        ...labelStyle
    };

    const disabledStyle = {
        backgroundColor: '#F7F7F7'
    };

    inputStyle = {
        width: '50%',
        padding: 12,
        border: '1px solid #D7D7D7',
        borderRadius: 5,
        resize: 'vertical',
        contain: 'strict',
        display: 'block',
        textAlign: 'left',
        backgroundColor: '#FFFDF4',
        color: '#414141',
        fontFamily: 'Roboto',
        gridColumn: '1 / -1',
        ...props.style,
        ...inputStyle,
        ...(disabled ? disabledStyle : {})
    };

    const handleChange = (event) => {
        if (maxLength && event.target.value.length > maxLength) {
            event.target.value = event.target.value.substring(0, maxLength + 1);
        }

        onChange(event);
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'auto max-content' }}>
            <label {...labelProps} id={`${id}-label`} style={labelStyle} htmlFor={name}>
                {title}
            </label>
            <AsLabel style={{ ...labelStyle, textAlign: 'right' }}>
                {typeof value === 'string' && maxLength ? `${value?.length}/${maxLength}` : ''}
            </AsLabel>
            <textarea
                {...inputProps}
                id={`${id}-input`}
                style={inputStyle}
                type='text'
                name={name}
                value={value || ''}
                disabled={disabled}
                onChange={handleChange}
                cols={cols}
                rows={rows}
                wrap={wrap}
                maxLength={maxLength}
            />
        </div>
    );
};

export default AsTextarea;
